<template>
    <li v-for="(goal, index) in activeGoals" :key="goal.id" class="goal-li">
        <div class="goal-name-div" @click.prevent="toggleAccordionClicked(index)">
        <div class="d-flex space-between">
            <div class="d-flex gap-5 align-items-center" >
                <div @click.stop.prevent="markGoalCompleted(goal)" :class="styalizeRadio(goal)">
                  <CheckIcon  :class="styalizeCheck(goal)" />
                </div>
                <span @click.stop.prevent="editGoalClicked(goal)" :class="goalNameClass(goal)">{{ goal.goal }}</span>
            </div>
            <div class="goal-action-div">
                <TrashIcon @click.stop.prevent="deleteGoalClicked(goal)" class="delete-goal"/>
                <CaretIcon class="caret-icon" :class="{ 'rotated': openSections[index] }"/>
            </div>
        </div>
        </div>
        <transition name="accordion">
        <ul v-if="goal.tasks" v-show="openSections[index]" >
            <TasksListV2 :goal="goal" :tasks="goal.tasks ? goal.tasks : []"  />
        </ul>
        </transition> 
    </li>

  </template>
  
  <script>
import CheckIcon from "@/components/icons/CheckIcon.vue";
import goalsService from '@/services/goalsService';
import TasksListV2 from '@/components/TasksListV2.vue';
import CaretIcon from '@/components/icons/CaretIcon.vue';
import { mapGetters } from 'vuex';
import actionsService from '@/services/actionsService.js'; 
import TrashIcon from "./icons/TrashIcon.vue";
import { showToastWithUndo } from "@/utils/toastHandler"; // Adjust path as needed

  export default {
    name: 'GoalsList',
    components: {
      CheckIcon,
      TasksListV2,
      CaretIcon,
      TrashIcon,
  },
    data(){
        return {
        activeIndex: null,
    }},
    computed: {
      ...mapGetters(['openSections','showGoalsModal']), // Access Vuex state via getter
        activeGoals() {
        return this.goals.filter(goal => !goal.date_deleted);
      },
  
    },
    emits: ['goalSelected','toggle-accordion'], // Declare the custom event
    props: {
        goals: {
        type: Array, // The expected type of the prop
        required: true, // Optional: Make the prop required
        },
    },
    mounted(){
    },
    methods: {
      editGoalClicked(goal){
        this.$store.commit('setShowGoalsModal', true)
        this.$store.commit('setActiveGoal', goal);
      },
        async deleteGoalClicked(goal){
          let goalCopy = {...goal};
          const date = new Date();
          goalCopy.date_deleted = date.toISOString().slice(0, 19).replace('T', ' ');
          await this.$store.dispatch('editGoal', goalCopy);

          goalCopy.date_deleted = null;
          // Render the custom component inside the toast
          showToastWithUndo({
            message: "Goal Deleted!",
            undoFunction: () => this.$store.dispatch('editGoal', goalCopy),
            type: "success",
            timeout: 5000
          });
        },
        goalNameClass(goal){
          let className= "goal-name";
          if(goal.date_completed){
            className += " strike";
          }
          return className
        },
        styalizeRadio(goal){
            if(goal.date_completed){
                return "radio-button-checked";
            }else{
                return "radio-button";
            }
        },
        styalizeCheck(goal){
            if(goal.date_completed){
                return "check-icon";
            }else{
                return "check-icon-hidden";
            }
        },
        async docsPing(){
            this.$store.dispatch('setSliderState', true);
            let result = await actionsService.createDocument();
            console.log(result);
            console.log("result");
            if (result.status === "success") {
              this.$store.dispatch('setGoogleDocsUrl', `https://docs.google.com/document/d/${result.documentId}/edit`);

            }
        },
        toggleAccordionClicked(index){
            this.$emit("toggle-accordion", index);
        },
        selectGoal(goal){
            this.$emit('goalSelected', goal); // Emit the selected goal
        },
        async markGoalCompleted(goal){
          if(goal.date_completed){
            goal.date_completed = null;
          }else{
            const now = new Date();
            goal.date_completed = now.toISOString().slice(0, 19).replace('T', ' ');  
          }
          goalsService.updateGoal({id: goal.id, date_completed: goal.date_completed});
        }
    }
  };
  </script>

<style scoped>
.goal-action-div{
  display: flex;
  gap: 5px;
  align-items: center;
  flex-grow: 1;
}
.delete-goal{
  width: 25px;
  color: var(--dark-color-6b);
  padding-left: 10px;
  display: none;
}
.goal-li:hover .delete-goal{
  display: block ;
}
.align-items-center{
  align-items: center;
}
.goal-name-div{
    padding-bottom: 5px;
    cursor: pointer;
}
.caret-icon{
    cursor: pointer;
    margin-left: auto;
    stroke: var(--white-color);
}

.goal-name{
    font-weight: bolder;
}

.goal-li{
    display: flex;
    flex-direction: column;
    margin-bottom: 2rem;
    gap: 1rem;
}

#accordion{
  width: 48rem;
}

.accordion-enter-active, .accordion-leave-active {
  transition: max-height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}

.accordion-enter-from, .accordion-leave-to {
  max-height: 0;
  opacity: 0;
}

.accordion-enter-to, .accordion-leave-from {
  max-height: 300px; /* Adjust this based on your content size */
  opacity: 1;
}
.goals-label{
    color: #d5d5d5;
    font-weight: 500;
    font-size: 18px;
}

.check-icon{
  stroke: white;
}
.check-icon-hidden{
  display: none;
}
.radio-button:hover .check-icon-hidden{
  display: block
}

.goal-li:hover .caret-icon{
    display: block;
}

.caret-icon {
  transition: transform 0.3s ease; /* Smooth rotation */
}

.caret-icon.rotated {
  transform: rotate(90deg);
}
</style>